import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import { trackClicks } from './utils/analytics';
import { finishHydration } from './utils/hydration';
import Home from './pages/Home';
import ServicesIndex from './pages/ServicesIndex';
import ServicePage from './pages/ServicePage';
import LaunchPlanPage from './pages/LaunchPlanPage';
import PricingPage from './pages/PricingPage';
import SituationsPage from './pages/SituationsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import FaqPage from './pages/FaqPage';
import BlogIndex from './pages/BlogIndex';
import BlogArticlePage from './pages/BlogArticlePage';
import NotFound from './pages/NotFound';

/**
 * Сайт більше не одна сторінка.
 *
 * Раніше весь контент жив за адресою «/», і через це шість напрямків послуг,
 * план запуску та стаття блогу не могли ранжуватися кожен за своєю темою —
 * Google бачив одну сторінку про все одразу. Тепер у кожного власна адреса,
 * власний заголовок і власна schema.org-розмітка.
 *
 * Кожен маршрут пререндериться в окремий build/<шлях>/index.html
 * (scripts/prerender.js), тож пошуковик отримує готовий HTML, а не порожній
 * контейнер під JavaScript.
 */
function App() {
  // Обробник кліків вішаємо один раз на весь застосунок, а не в кожній
  // сторінці: він і так слухає document, і повторне навішування лише
  // дублювало б події.
  useEffect(() => trackClicks(), []);

  // Ефекти запускаються вже після коміту гідрації: перший екран змонтовано,
  // і все, що з'явиться далі, — це перехід між сторінками з анімацією появи.
  useEffect(() => {
    finishHydration();
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <ScrollToTop />
        <div className="App overflow-x-hidden supports-[overflow:clip]:overflow-x-clip min-h-screen flex flex-col">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pro-kompaniyu" element={<AboutPage />} />
            <Route path="/poslugy" element={<ServicesIndex />} />
            <Route path="/poslugy/:slug" element={<ServicePage />} />
            <Route path="/plan-zapusku-kliniky" element={<LaunchPlanPage />} />
            <Route path="/z-chogo-pochaty" element={<SituationsPage />} />
            <Route path="/tsinova-polityka" element={<PricingPage />} />
            <Route path="/pytannya" element={<FaqPage />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogArticlePage />} />
            <Route path="/kontakty" element={<ContactPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
